/**
 * Reasoner (assistant chat) app routes — keep in sync with AppRoutes Reasoner paths.
 * Explicit checks avoid fragile prefix lists (e.g. "/" + "/" → startsWith("//")).
 */
export function isReasonerAppPath(pathname: string): boolean {
  return pathname === '/' || pathname.startsWith('/reVeal');
}
